/**
 * Keep decorative / hidden regions out of the tab order.
 * Judge.me and marquee copies load late, so we watch the DOM.
 */
(function () {
  function defocusHidden(root) {
    if (!root || root.nodeType !== 1) return;
    const scopes = [];
    if (root.matches?.('[aria-hidden="true"], [inert]')) scopes.push(root);
    root.querySelectorAll?.('[aria-hidden="true"], [inert]').forEach((el) => scopes.push(el));
    scopes.forEach((scope) => {
      scope.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach((el) => {
        if (el.getAttribute('tabindex') === '-1') return;
        el.setAttribute('tabindex', '-1');
      });
    });
  }

  function tameJudgeme(root) {
    (root.querySelectorAll ? root : document).querySelectorAll?.('.jdgm-rev-widg__summary-stars').forEach((el) => {
      el.querySelectorAll('a, button').forEach((child) => {
        child.setAttribute('tabindex', '-1');
        child.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function run(root) {
    defocusHidden(root === document ? document.body : root);
    tameJudgeme(root === document ? document : root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document));
  } else {
    run(document);
  }

  const observer = new MutationObserver((records) => {
    for (const rec of records) {
      rec.addedNodes.forEach((node) => {
        if (node.nodeType === 1) run(node);
      });
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
